import { Box, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import Bento from 'UiKit/bento';

import OverviewCard from 'View/host/component/overview-card';
import { useHostState } from 'View/host/state';
import AchievementRank from 'Component/achievement-rank';
import { ChevronRightIcon, PaperclipIcon } from 'Asset/icon';
import { TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const HostDashboardMenu = ({ data, isFetching }) => {
  const { t } = useTranslation('host-home');
  const navigate = useNavigate();

  const { filterState } = useHostState();

  const selectedYearMonth = moment(filterState?.yearMonth).format('YYYY-MM-DD');

  const summary = data?.liveOverview;

  const handleScheduledLiveClick = () => navigate(`/host/scheduled?yearMonth=${selectedYearMonth}`);
  const handleUpcomingLiveClick = () => navigate(`/host/upcoming?yearMonth=${selectedYearMonth}`);
  const handlePastLiveClick = () => navigate(`/host/past?yearMonth=${selectedYearMonth}`);
  const handleAchievementClick = () => navigate(`/host/achievement-detail`);
  const handleBriefLiveClick = () => navigate(`/host/brief-live`);

  return (
    <Box className={styles['dashboard-menu__container']}>
      <Box className={styles['dashboard-menu__achivement-brief--container']}>
        <Bento>
          <Box className={styles['dashboard-menu__achievement--card']} onClick={handleAchievementClick}>
            <Flex width={'100%'} justifyContent={'space-between'}>
              <AchievementRank rankPosition={data?.achievement?.rankPosition} size="sm" />
              <ChevronRightIcon size="16px" />
            </Flex>
            <TextSemiBold>{t('menu.achievement')}</TextSemiBold>
          </Box>
        </Bento>

        <Bento>
          <Box className={styles['dashboard-menu__brief-live--card']} onClick={handleBriefLiveClick}>
            <Flex width={'100%'} justifyContent={'space-between'}>
              <Box className={styles['dashboard-menu__brief--icon']}>
                <PaperclipIcon size="18px" color="var(--color-primary)" />
              </Box>
              <ChevronRightIcon size="16px" />
            </Flex>
            <TextSemiBold>{t('menu.brief_live')}</TextSemiBold>
          </Box>
        </Bento>
      </Box>
      <Box className={styles['dashboard-menu__live-card--container']}>
        <Bento>
          <OverviewCard
            isLoading={isFetching}
            title={t('menu.scheduled_live')}
            count={summary?.total}
            isNavigable={true}
            bgColor="var(--color-neutral20)"
            valueColor="var(--color-semantic-text)"
            onClick={handleScheduledLiveClick}
          />
        </Bento>

        <Bento>
          <OverviewCard
            isLoading={isFetching}
            title={t('menu.upcoming_live')}
            count={summary?.upcoming}
            isNavigable={true}
            bgColor="var(--color-primary20)"
            valueColor="var(--color-primary60)"
            onClick={handleUpcomingLiveClick}
          />
        </Bento>

        <Bento>
          <OverviewCard
            isLoading={isFetching}
            title={t('menu.completed_live')}
            count={summary?.finished}
            isNavigable={true}
            bgColor="var(--color-success20)"
            valueColor="var(--color-success70)"
            onClick={handlePastLiveClick}
          />
        </Bento>
      </Box>
    </Box>
  );
};

export default HostDashboardMenu;
